module.exports = __webpack_public_path__ + "img/icn_close.cc579dd2.svg";